<template lang="pug">
  .kraus-tooltip(v-if="visible")
    .background
    .tooltip-wrapper(:style="wrapperStyle")
      .tooltip-corner-wrapper(:style="cornerWrapperStyle")
        .tooltip-corner(:class="cornerPosition")
      .tooltip-content(v-if="this.currentData")
        .title {{$t(this.currentData.title)}}
        .text {{$t(this.currentData.text)}}
        tooltip-controller(:stepsCount="currentList.length", :currentStep="this.step", @next="onNextStep", @skipAll="onSkipAll")
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import TooltipController from '@/components/_common/ui/Tooltip/TooltipController';
import { eventBus } from '@/main';
import EventBusEvents from '@/common/EventBusEvents';

export default {
  name: 'KrausTooltip',
  components: { TooltipController },
  data() {
    return {
      visible: false,
      cornerPosition: 'top',
      cornerDelta: 0,
      size: {
        width: 380,
        height: 182
      },
      step: 0,
      data: {
        '2D': [
          {
            selector: null,
            centerOffset: {
              x: -301,
              y: 20
            },
            title: 'TOOLTIP_1_TITLE',
            text: 'TOOLTIP_1_TEXT'
          },
          {
            selector: '.left-menu-item.box',
            title: 'TOOLTIP_2_TITLE',
            text: 'TOOLTIP_2_TEXT'
          },
          {
            selector: '.history-buttons',
            title: 'TOOLTIP_3_TITLE',
            text: 'TOOLTIP_3_TEXT'
          },
          {
            selector: '.stage-select',
            title: 'TOOLTIP_4_TITLE',
            text: 'TOOLTIP_4_TEXT'
          },
          {
            selector: '.site-header .menu-button',
            title: 'TOOLTIP_5_TITLE',
            text: 'TOOLTIP_5_TEXT'
          },
          {
            selector: '.camera-button',
            title: 'TOOLTIP_6_TITLE',
            text: 'TOOLTIP_6_TEXT'
          },
          {
            selector: '.clear-project-button',
            title: 'TOOLTIP_7_TITLE',
            text: 'TOOLTIP_7_TEXT'
          },
          {
            selector: '.container-items',
            centerOffset: {x: -170, y: -230},
            title: 'TOOLTIP_8_TITLE',
            text: 'TOOLTIP_8_TEXT'
          },
          {
            selector: '.site-header .kraus-switcher',
            title: 'TOOLTIP_9_TITLE',
            text: 'TOOLTIP_9_TEXT'
          },
          {
            selector: '.result-information .button-wrapper',
            title: 'TOOLTIP_10_TITLE',
            text: 'TOOLTIP_10_TEXT'
          },
          {
            selector: '.tooltip-button',
            title: 'TOOLTIP_11_TITLE',
            text: 'TOOLTIP_11_TEXT'
          },
        ],
        '3D': [
          {
            selector: '.site-header .kraus-switcher',
            title: 'TOOLTIP_12_TITLE',
            text: 'TOOLTIP_12_TEXT'
          },
          {
            selector: '.editor-left-menu .left-menu-item.decoration',
            title: 'TOOLTIP_13_TITLE',
            text: 'TOOLTIP_13_TEXT'
          },
          {
            selector: '.walls-mode-select',
            title: 'TOOLTIP_14_TITLE',
            text: 'TOOLTIP_14_TEXT'
          },
          {
            selector: '.site-header .camera-button',
            title: 'TOOLTIP_15_TITLE',
            text: 'TOOLTIP_15_TEXT'
          },
          {
            selector: '.tooltip-button',
            title: 'TOOLTIP_16_TITLE',
            text: 'TOOLTIP_16_TEXT'
          },
        ]
      }
    }
  },

  created() {
    eventBus.$on(EventBusEvents.ShowTooltips, this.show)
    eventBus.$on(EventBusEvents.HideTooltips, this.hide)
  },

  destroyed() {
    eventBus.$off(EventBusEvents.ShowTooltips, this.show)
    eventBus.$off(EventBusEvents.HideTooltips, this.hide)
  },

  computed: {
    ...mapGetters([
      'containerType',
      'editorType'
    ]),

    currentList() {
      return this.data[this.editorType]
    },

    currentData() {
      return this.currentList[this.step]
    },

    point() {
      const {selector, centerOffset} = this.currentData
      const point = {x: 0, y: 0}

      if (selector) {
        const element = document.querySelector(selector)
        const rect = element.getBoundingClientRect()
        point.x = rect.x + rect.width / 2
        point.y = rect.y + rect.height / 2

        if (centerOffset) {
          point.x += centerOffset.x
          point.y += centerOffset.y
        }

      } else if (centerOffset) {
        point.x = (window.innerWidth - 324) / 2 + centerOffset.x
        point.y = window.innerHeight / 2 + centerOffset.y
      }

      return point
    },

    wrapperPosition() {
      const position = {x: this.point.x - 330, y: this.point.y + 60}
      this.cornerPosition = 'top'
      this.cornerDelta = 0

      if (this.point.y > window.innerHeight / 2) {
        this.cornerPosition = 'bottom'
        position.y = this.point.y - 240
      }

      if (position.x < 0) {
        position.x = this.point.x + 60
        position.y = this.point.y - 50
        this.cornerPosition = 'left'
      }

      if (this.point.y > window.innerHeight / 2 - 100 && this.point.x > window.innerWidth - 350) {
        this.cornerPosition = 'right'
        position.x = this.point.x - 400
        position.y = this.point.y - 50
      }

      if (position.y + this.size.height > window.innerHeight) {
        const delta = ((position.y + this.size.height) - window.innerHeight) + 20
        position.y -= delta
        this.cornerDelta = delta
      }

      return position
    },

    wrapperStyle() {
      return {
        top: this.wrapperPosition.y + 'px',
        left: this.wrapperPosition.x + 'px'
      }
    },

    cornerWrapperStyle() {
      if (this.cornerPosition === 'left') {
        return {
          top: this.cornerDelta + 'px'
        }
      } else if (this.cornerPosition === 'bottom') {
        return {
          top: null,
          right: '50px',
          bottom: '10px'
        }
      } else if (this.cornerPosition === 'right') {
        return {
          top: null,
          right: '10px',
          bottom: '150px'
        }
      }
    }
  },

  watch: {
    visible(visible) {
      if (visible) this.step = 0
    },

    containerType(val) {
      if (val) {
        this.tooltipsShowed(this.editorType).then((showed) => {
          if (!showed) {
            this.addTooltipsToShowedList(this.editorType)
            this.show()
          }
        })
      }
    }
  },

  methods: {
    ...mapActions([
      'tooltipsShowed',
      'addTooltipsToShowedList'
    ]),

    onNextStep() {
      this.step ++
      if (this.step >= this.currentList.length) this.hide()
    },

    onSkipAll() {
      this.hide()
    },

    hide() {
      this.visible = false
      if (this.editorType === '3D') {
        eventBus.$emit(EventBusEvents.ShowSmallTooltip, {
          text: this.$t('TOOLTIP_3D')
        })
      } else {
        eventBus.$emit(EventBusEvents.ShowSmallTooltip, {
          text: this.$t('TOOLTIP_2D')
        })
      }
    },

    show() {
      if (!this.visible) {
        this.visible = true
      }
    }
  }
}
</script>
